export const CustomTone = {
	PLAYFUL: 'playful',
	PROFESSIONAL: 'professional',
	CONVERSATIONAL: 'conversational',
	SURPRISE: 'surprise',
} as const;

export type CustomToneType = (typeof CustomTone)[keyof typeof CustomTone];

export const CustomLength = {
	SHORT: 'short',
	MEDIUM: 'medium',
	LONG: 'long',
} as const;

export type CustomLengthType = (typeof CustomLength)[keyof typeof CustomLength];

export type CustomizationType = {
	tone: CustomToneType;
	length: CustomLengthType;
};
